import {colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    paddingLeft: '18px',
    position: 'relative',
  },
  innerContainer: {
    paddingTop: '8px',
    paddingBottom: '14px',
  },
  childContainer: {
    borderLeft: '1px solid rgba(0,0,0,0.36)',
    // borderRight: '1px solid rgba(0,0,0,0.36)',
    borderBottom: '1px solid rgba(0,0,0,0.36)',
    marginBottom: '28px',
    // paddingRight: '18px'
  },
  innerChildContainer: {
    borderLeft: 0,
    borderRight: 0,
  },
  staticProperty: {
    fontSize: '1.28rem',
    margin: 0,
  },
  indentLine: {
    position: 'absolute',
    top: '20px',
    bottom: 'auto',
    left: 0,
    right: 'auto',
    width: '12px',
    height: '1px',
    background: 'rgba(0,0,0,0.36)'
  },
}
